import { createContext } from "react";
export var LayoutContext = createContext({});
export var StickyListContext = createContext({});
StickyListContext.displayName = "StickyListContext";
export var LayoutContextProvider = LayoutContext.Provider;
export var LayoutContextConsumer = LayoutContext.Consumer;
export var StickyListContextProvider = StickyListContext.Provider;
export var StickyListContextConsumer = StickyListContext.Consumer;
